module.exports = __webpack_public_path__ + "static/6-4020743d33fe453fa3e881870b359b99.png";